import React from 'react';
import {useDispatch} from "react-redux";
import Modal from "react-bootstrap/Modal";
import {Field, FieldProps, Form, Formik} from "formik";
import NumberFormat from "react-number-format";
import Button from "react-bootstrap/Button";
import {ProductPriceChangeDialogProps} from "./types";
import {useTranslation} from "react-i18next";
import * as Yup from 'yup';
import {editPortion} from "../../actions";
import {requiredMessage} from "../../../../../../common/utils/validation";
import TextInput from "../../../../../../common/components/TextInput";
import classNames from "classnames";
import styles from "./ProductPriceChangeDialog.module.scss";
import BootstrapForm from "react-bootstrap/Form";
import Checkbox from "../../../../../../common/components/Checkbox";

const validationSchema = Yup.object().shape({
  price: Yup.number().min(1).required(requiredMessage())
})

/**
 * Диалог изменения цены блюда
 */
const ProductPriceChangeDialog: React.VFC<ProductPriceChangeDialogProps> = ({
  info,
  closeDialog,
  hasFoodByBonuses,
}) => {
  
  const dispatch = useDispatch();
  const {t} = useTranslation();
  
  return <Modal show={!!info} onHide={closeDialog} centered>
    <Modal.Header closeButton>
      <Modal.Title>{t('features.catalog.products.actionEditItem')}</Modal.Title>
    </Modal.Header>
    <Formik
      enableReinitialize
      initialValues={{
        price: info?.price ?? 0,
        isBonus: info?.isBonus ?? false,
      }}
      validationSchema={validationSchema}
      onSubmit={({price}) => {
        if (info) {
          dispatch(editPortion(info.compositeId, {price}))
          closeDialog();
        }
      }}>
      {({values, setFieldValue, isValid}) =>
        <Form>
          <Modal.Body>
            <div className="fw-600 mb-2">
              {info?.name}
            </div>
            {!!info?.portionSize && <div className={classNames("mb-2", styles.desc)}>
              {info.portionSize}
            </div>}
            {!!info?.description && <div className={classNames("mb-2_5", styles.desc)}>
              {info.description}
            </div>}
            <BootstrapForm.Label className="mb-1" htmlFor="price">
              {t('features.catalog.products.productPrice')}
            </BootstrapForm.Label>
            <Field name="price">
              {(props: FieldProps) =>
                <NumberFormat
                  id={"price"}
                  onValueChange={({floatValue}) => setFieldValue('price', floatValue ?? 0)}
                  value={values.price}
                  allowNegative={false}
                  onBlur={props.field.onBlur}
                  customInput={TextInput}
                  thousandSeparator={" "}
                />}
            </Field>
            {hasFoodByBonuses && <div className="mt-2_5">
              <Checkbox
                id="isBonus"
                checked={values.isBonus}
                onChange={() => {}}
                disabled
                label={t('features.catalog.products.isBonus')}
              />
            </div>}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="outline-secondary" onClick={closeDialog}>
              {t('common.actionCancel')}
            </Button>
            <Button variant="outline-primary"
                    type="submit"
                    disabled={!isValid}
            >
              {t('common.actionSubmit')}
            </Button>
          </Modal.Footer>
        </Form>}
    </Formik>
  </Modal>
}

export default ProductPriceChangeDialog;
